import * as React from "react";
import { connect } from "react-redux";
import { merge } from "glamor";
import theme from "styles/theme";

interface IPanelProps {
    children: any;
    panelSize?: number;
}

interface IMappedProps {
    shouldOffsetForSidePanel: boolean;
}

const Panel: React.FC<IPanelProps & IMappedProps> = ({ children, panelSize, shouldOffsetForSidePanel }) => {
    const styles = merge({
        display: "block",
        position: "fixed",
        top: "60px",
        bottom: "0px",
        right: shouldOffsetForSidePanel ? `${theme.sidebar.width}px` : "0px",
        borderLeft: "1px solid #e0e0e0",
        transition: "width 0.3s",
        overflowY: "auto",
        backgroundColor: "white",
        zIndex: 2,
        width: `${panelSize}px`,
    });

    return (
        <div id="pagePanel" {...styles}>
            {children}
        </div>
    );
};

const mapStateToProps = (state) => ({
    shouldOffsetForSidePanel: state.app.sidePanelOpen,
});

export default connect<IMappedProps, null, IPanelProps>(mapStateToProps)(Panel);
